import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { DatatableComponent } from './datatable/datatable.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertsModule } from './alerts/alerts.module';
import { AsyncActionButtonComponent } from './async-action-button/async-action-button.component';
import { SimpleTableComponent } from './simple-table/simple-table.component';
import { AdvancedSearchModule } from './advanced-search/advanced-search.module';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { MatSelectModule } from '@angular/material/select';
import { MatRippleModule } from '@angular/material/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { TemplateEditorComponent } from './template-editor/template-editor.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CardImageTooltipDirective } from './card-image-tooltip.directive';
import { ArrangableSelectorMenuComponent } from './arrangable-selector-menu/arrangable-selector-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { LandingToolbarComponent } from './landing-toolbar/landing-toolbar.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MobileWarningComponent } from './mobile-warning/mobile-warning.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
    declarations: [
        DatatableComponent,
        AsyncActionButtonComponent,
        SimpleTableComponent,
        ContextMenuComponent,
        TemplateEditorComponent,
        CardImageTooltipDirective,
        ArrangableSelectorMenuComponent,
        LandingToolbarComponent,
        MobileWarningComponent,
        ConfirmDialogComponent
    ],
    exports: [
        DatatableComponent,
        AdvancedSearchModule,
        AsyncActionButtonComponent,
        AlertsModule,
        SimpleTableComponent,
        NgCommonModule,
        MatTableModule,
        MatSortModule,
        MatCheckboxModule,
        MatPaginatorModule,
        RouterModule,
        MatChipsModule,
        MatIconModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCardModule,
        MatButtonModule,
        MatInputModule,
        MatProgressSpinnerModule,
        ContextMenuComponent,
        TemplateEditorComponent,
        CardImageTooltipDirective,
        ArrangableSelectorMenuComponent,
        LandingToolbarComponent
    ],
    imports: [
        NgCommonModule,
        MatTableModule,
        MatSortModule,
        MatCheckboxModule,
        MatPaginatorModule,
        RouterModule,
        MatChipsModule,
        MatIconModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCardModule,
        MatButtonModule,
        MatInputModule,
        AlertsModule,
        MatProgressSpinnerModule,
        AdvancedSearchModule,
        MatSelectModule,
        MatRippleModule,
        DragDropModule,
        EditorModule,
        FormsModule,
        MatTooltipModule,
        MatMenuModule,
        MatDividerModule,
        MatToolbarModule,
        MatProgressBarModule,
        MatDialogModule
    ],
    providers: [
        {provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js'}
    ]
})
export class CommonModule {}
